import { useEffect, useState } from "react";
import { IVideo } from "../interfaces";
// import { useSocket } from "../utils/socket";
import useCourseStore from "../store/course";
import api, { studioApi } from "../api";
import { ICourse } from "../screens/list";
import { message } from "antd";

export default function useStudio(params) {
  const [latest, setLatest] = useState<IVideo>({ title: "" } as IVideo);
  const [course, setCourse] = useState<ICourse>();
  const [iframeKey, setIframeKey] = useState(0);
  // const socket = useSocket();
  const { getCourse } = useCourseStore();

  const token = localStorage.getItem("AUTH_TOKEN");

  const getLatest = async () => {
    try {
      const { data } = await studioApi.get<IVideo>(
      `videos/${params?.slug}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      setLatest(data);
      setCourse(getCourse(data.course_id));
    } catch (error: any) {
      message.error(error.message)
    }
  };



  useEffect(() => {
    getLatest();
  }, [latest._id]);

  return { video: latest, course, setVideo: setLatest, iframeKey };
}
